import { useState } from "react"

export const CustomInput = ({ updateProducto, producto, field = '', editable = false, setProducto }) => {
    const [element, setElement] = useState(producto[field])
    //let value = producto[field]
    if(field === 'Precio') {
        let value = Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(producto[field])
        setElement(value)
    }

    const [inputValue, setInputValue] = useState(element)

    const handleChange = (e) => { 
        setInputValue(e.target.value)
    }

    const handleBlur = (e) => {
        updateProducto(producto, field, e.target.value, setProducto)
    }

    return (
        <div className="group flex relative">
          <input 
            className="text-sm bg-transparent border-none focus:ring-0 flex w-full"
            type='text' 
            readOnly={!editable}
            onChange={handleChange} 
            onBlur={handleBlur}
            value={inputValue}
          /> 
          <span className="group-hover:opacity-100 transition-opacity /bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 
         -translate-x-1/2 translate-y-full opacity-0 m-4 mx-auto">{inputValue}</span>
        </div>
    )
}